import { Range } from "immutable";

import { createAPI } from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";

export const CREATE_NEWSLETTER = "CREATE_NEWSLETTER";
export const CREATE_NEWSLETTER_SUCCESS = "CREATE_NEWSLETTER_SUCCESS";
export const CREATE_NEWSLETTER_ERROR = "CREATE_NEWSLETTER_ERROR";
export const CREATE_NEWSLETTER_FINALLY = "CREATE_NEWSLETTER_FINALLY";

export const NEWSLETTER_CLEAR_ERROR = "NEWSLETTER_CLEAR_ERROR";
export const NEWSLETTER_CLEAR_FORM = "NEWSLETTER_CLEAR_FORM";

export const NEWSLETTER_SET_IS_OPEN = "NEWSLETTER_SET_IS_OPEN";

const validateCreate = (validate, msg, fields) =>
  validate(fields)
    .prop("email")
    .required(msg["app.validation.required"])
    .email("Wpisany email jest niepoprawny")
    .prop("policy")
    .checked(msg["app.validation.policy"])
    .getErrors();

export const create = data => async (dispatch, getState, utils) => {
  const action = CREATE_NEWSLETTER;

  data.type = "contactPageForm";
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      createAPI,
      data,
      {
        headers: {
          "Content-Type": "application/json"
        }
      },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const clearError = field => ({
  type: NEWSLETTER_CLEAR_ERROR,
  payload: { field }
});

export const clearForm = clearSentStatus => ({
  type: NEWSLETTER_CLEAR_FORM,
  payload: { clearSentStatus }
});

export const setIsOpen = isOpen => ({
  type: NEWSLETTER_SET_IS_OPEN,
  payload: { isOpen }
});



/** WEBPACK FOOTER **
 ** ./src/common/newsletter/actions.js
 **/